import { createReducer } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import sessionStorage from 'redux-persist/lib/storage/session';

import { ActionSuccessType, HIDE_DESIGNS_OVERLAY, SIGN_IN, SIGN_IN_WITH_TOKEN } from 'constants/redux-actions';

const initState = {};
const persistConfig = { key: 'designsOverlay', storage: sessionStorage };

const designsOverlayReducer = createReducer(initState, {
  [ActionSuccessType(SIGN_IN)]: () => ({
    hidden: false,
  }),
  [ActionSuccessType(SIGN_IN_WITH_TOKEN)]: () => ({
    hidden: false,
  }),
  [HIDE_DESIGNS_OVERLAY]: () => ({ hidden: true }),
});

export default persistReducer(persistConfig, designsOverlayReducer);
